import Data from '../data/home';
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import YouTubeEmbed from '../components/YouTubeEmbed';

function Jumbotron(props) {
  const [heroData, setHeroData] = useState(Data.heroes);
  const [marketingData, setMarketingData] = useState(Data.marketing);
  const [heroDetails, setHeroDetails] = useState(heroData[props.id]);
  const [marketingDetail, setMarketingDetail] = useState(marketingData[props.contentId]);
  console.log("hero data: " + props.id)
  return (
    <header style={{ 
      paddingTop: props.paddingTop, 
      backgroundColor: props.backgroundColor,
      borderTopWidth: props.borderwidth,
      borderTopColor: props.bordercolor,
      borderTopStyle: props.bordertype,
      borderBottomWidth: props.borderwidth,
      borderBottomColor: props.bordercolor,
      borderBottomStyle: props.bordertype }}>

      <div 
        className="jumbotron" 
        style={
          { 
            height: props.height + 'px', 
            backgroundImage: 'linear-gradient(' + props.gradientDirection + ', ' + props.gradientRgba + '), url("/images/' + heroDetails.image + '")', 
            backgroundSize: props.backgroundSize, 
            backgroundRepeat: props.backgroundRepeat, 
            backgroundColor: props.backgroundColor, 
            backgroundPosition: props.backgroundPosition,
            maxWidth: props.maxWidth,
            margin: props.margin
          }
        }>
        <div className="container" style={{ padding: '30px 0' }}>
          <div className="row">
            <div className="col-12" style={{ position: 'relative' }}>
              <div className="col-lg-8">
                <h1 className="text-left">{heroDetails.title}</h1>
                <p className="text-left">{ marketingDetail.tags.map((tag, index, tags) => (
                  <span key={tag + index}>
                    <Link to={"/Search/" + tag}>{ tag }</Link>{ index == tags.length - 1 ? " " : " | " }
                  </span>
                )) }</p>
                <p className="text-left" dangerouslySetInnerHTML={{__html: heroDetails.body}}></p>
                { heroDetails?.yt_container && (
                  <div style={{ maxWidth: "600px" }}>
                    <YouTubeEmbed url={heroDetails.yt_url} />
                  </div>
                )
              }
              <p>&nbsp;</p>
              <p className="text-left">
                { heroDetails?.btn_1 && ( 
                  <a className={ 'btn btn-lg btn-' + heroDetails.btn_1_type + ' btn-one' } href={ heroDetails.btn_1_url } role="button" style={ heroDetails.btn_1 ? { fontWeight: '700' } : { display: 'none' }} target={ heroDetails.btn_1_target? "_blank" : "" } >{ heroDetails.btn_1_title }</a> 
                )}
                { heroDetails?.btn_2 && ( 
                  <a className={ 'btn btn-lg btn-' + heroDetails.btn_2_type + ' btn-two' } href={ heroDetails.btn_2_url } role="button" style={ heroDetails.btn_2 ? { fontWeight: '700' } : { display: 'none' }} target={ heroDetails.btn_2_target? "_blank" : "" }>{ heroDetails.btn_2_title }</a> 
                )}
                { heroDetails?.btn_3 && (
                  <a className={ 'btn btn-lg btn-' + heroDetails.btn_3_type + ' btn-three'} href={ heroDetails.btn_3_url } role="button" style={ heroDetails.btn_3 ? { fontWeight: '700' } : { display: 'none' }} target={ heroDetails.btn_3_target? "_blank" : "" } >{ heroDetails.btn_3_title }</a>
                )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Jumbotron;
